import React from "react";
import { CheckCheck } from "lucide-react";
import classNames from "classnames/bind";
import styles from "../../CaseChatCard.module.scss";
const cx = classNames.bind(styles);

const ChatMessageGroup = ({ group, isReceiver, time, avatar, isLast }) => {
    const lastMsg = group[group.length - 1];
    const showCheck = isLast && !isReceiver && lastMsg.IsRead;
    return (
        <div className="d-flex chat-message">
            <div className={`d-flex flex-1 ${isReceiver ? "" : "justify-content-end"}`}>
                <div className="w-100 w-xxl-75">
                    <div className={`d-flex hover-actions-trigger ${isReceiver ? "" : "flex-end-center"}`}>
                        {isReceiver && (
                            <div className="me-1 flex-shrink-0 avatar avatar-m">
                                <img alt="avatar" className="rounded-circle" src={avatar} />
                            </div>
                        )}
                        <div className={`w-75 d-flex flex-column ${isReceiver ? "" : "align-items-end"}`}>
                            {
                                group.map((msg, i) => {
                                    const isFailStatus = msg.Status === "failed";
                                    return(
                                        <div key={i} className={cx("chat-message-item", `mb-1 border bg-body-emphasis fs-9 ${isFailStatus ? "text-danger" : ""}`)}>
                                            {msg.ChatContent}
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>
                    <div className={`d-flex gap-1 fs-10 ms-7 ${isReceiver ? "" : "flex-end-center"}`}>
                        <p className="mb-0 text-body-tertiary text-opacity-85 fw-semibold">{time}</p>
                        {!showCheck && (
                            <span className="text-primary">
                                {!isReceiver && isLast && lastMsg.Status === "sending" && "Sending..."}
                                {!isReceiver && isLast && (lastMsg.Status === "sent" || lastMsg.Status?.toLowerCase() === "success") && "Sent"}
                            </span>
                        )}
                        {showCheck && (
                            <CheckCheck className="text-success" size={12} />
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ChatMessageGroup;